import { RouteRecordRaw } from 'vue-router'

export const virtualClinicRoutes: RouteRecordRaw[] = [
  {
    path: '/virtualclinic',
    name: 'virtualclinic',
    component: () =>
      /* webpackChunkName: "VirtualClinicView" */
      import('@/views/virtualclinic/VirtualClinicView.vue'),
    meta: {
      onlyLoggedIn: true,
      title: 'PA virtual'
    }
  },
  {
    path: '/virtualclinic/history',
    name: 'virtualClinicHistory',
    component: () =>
      /* webpackChunkName: "VirtualClinicHistoryView" */
      import('@/views/virtualclinic/VirtualClinicHistoryView.vue'),
    meta: {
      onlyLoggedIn: true,
      title: 'Histórico PA virtual'
    }
  }
]
